<template lang="pug">
div(v-if='$store.state.student.name')
  router-view
  //- preload
</template>

<script>
import preload from './components/Stu/StuPractice/StuExam/preLoad'
import { getStudentInfo, sso, adjustScore } from '@/api/index'
import Util from '@/util/Util'

const token_ = Util.getCookieValue('token')

export default {
  name: 'App',
  components: { preload },
  methods: {
    initSocket(data) {
      let that = this
      this.$socket.on('connect', () => {
        that.$socket.emit('login', {
          uid: 's_' + data.id,
          scid: 'sc_' + data.school_class_id || '',
          cname: data.category_name || '',
          cid: data.country_id || '',
          lid: data.layer_id ? 'l_' + data.layer_id : ''
        })
      })

      this.sockets.subscribe('new_msg', data => {
        console.info('new_msg', data)
      })
      this.sockets.subscribe('update_online_count', data => {
        console.info('update_online_count', data)
      })
      if (!token_) {
        this.sockets.subscribe('oss', data => {
          // 单点登录
          this.$store.dispatch('oss', data)
        })
      }
      this.sockets.subscribe('newTask', data => {
        // 新练习推送
        this.$store.dispatch('newTask', data)
      })
    },
    getStudentInfo() {
      getStudentInfo(res => {
        if (res.status === 1) {
          let data = res.data
          this.$store.commit('student/init', data)
          this.$store.commit('setVipInfo', data.vip)
          localStorage.setItem('defaultGrade', JSON.stringify(res.data.defaultGrade))
          localStorage.setItem('studentId', data.id)
          if (!token_) {
            if (!localStorage.getItem('socketToken')) {
              localStorage.setItem(
                'socketToken',
                new Date().getTime() + Math.random().toFixed(10)
              )
            }
            sso({ token: localStorage.getItem('socketToken') })
          }
          // 2020.08.06 线上没开 所以注释websocket
          // this.initSocket(data)
        } else this.requestFail(res)
      })
    },
    adjustScore() {
      adjustScore().then(res => {
        if (res.status === 1) {
          this.$store.commit('setCoefficient', res.data)
        }
      })
    }
  },
  beforeCreate() {},
  created() {
    window.$alert = this.$alert
    window.$alertOnly = this.$alertOnly
    document.addEventListener('copy', e => {
      let element = e.target
      let falg = false
      while (element && !falg) {
        falg = element.classList.contains('allow-replication')
        element = element.parentElement
      }
      if (!falg) {
        e.preventDefault()
        this.$alertOnly(
          '抱歉！暂不支持内容复制',
          '尊重知识从你我做起，如有疑问，请联系我们<br>400-018-9011',
          {
            useHtml: true,
            confirmTxt: '我知道了'
          }
        )
      }
    })
    document.title = window.ConfigNew.header.title
    const _isjf =
      window.navigator.userAgent.match(/Electron/) && !localStorage.getItem('exetype')
    this.$store.commit('setJF', _isjf)

    if (_isjf || localStorage.getItem('t2s')) {
      this.getStudentInfo()
      this.adjustScore()
    } else {
      this.$queueUp().then(() => {
        // 获取学生信息，存入store中
        this.getStudentInfo()
        this.adjustScore()
      })
    }
  }
}
</script>

<style>
@import url('./ui/css/ui.css');
#app {
  min-width: 1180px;
  min-height: 100vh;
}
.iconfont {
  font-family: 'iconfont' !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}
@font-face {
  font-family: 'iconfont'; /* project id 986912 */
  src: url('//at.alicdn.com/t/font_986912_8c1wwvxsspd.eot');
  src: url('//at.alicdn.com/t/font_986912_8c1wwvxsspd.eot?#iefix')
      format('embedded-opentype'),
    url('//at.alicdn.com/t/font_986912_8c1wwvxsspd.woff2') format('woff2'),
    url('//at.alicdn.com/t/font_986912_8c1wwvxsspd.woff') format('woff'),
    url('//at.alicdn.com/t/font_986912_8c1wwvxsspd.ttf') format('truetype'),
    url('//at.alicdn.com/t/font_986912_8c1wwvxsspd.svg#iconfont') format('svg');
}
.loadingWarp {
  width: 100%;
  height: 668px;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue